<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-02 15:47:08
 * @Description: 累计用电量与放电量
 * @FilePath: \sheyang\src\module\overview\leftContent\cumulativeE.vue
-->
<template>
  <div class="cumulative-ele">
    <div style="width: 100%;z-index:3;cursor: pointer" @click="handleNavGo">
      <pub-info-title :title="'累计用电量与V2G放电量'" />
    </div>
    <!-- <div ref="eleLine" id="eleLine"></div> -->
    <div class="chart-container">
      <pub-line-chart
        :twoSeries="true"
        :xAxisData="dateData"
        :seriesData="eleData"
        :seriesData2="dischargeData"
        :extraOption="extraOption"
      />
    </div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import pubInfoTitle from '@/components/infoTitle/index.vue';
import pubLineChart from '@/components/pubLineChart/index.vue';
import { getMaxValue, getMinValue } from '@/utils';

// 折线图实例
export default {
  name: 'cumulativeEle',
  components: {
    pubInfoTitle,
    pubLineChart,
  },
  props: {
    dateData: {
      type: Array,
      default: () => [],
    },
    eleData: {
      type: Array,
      default: () => [],
    },
    dischargeData: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    eleData: {
      deep: true,
      handler() {
        // this.lineChartsInit();
      },
    },
    dischargeData: {
      deep: true,
      handler() {
        // this.lineChartsInit();
      },
    },
  },
  data() {
    return {
      chart: null, // 图表实例
      extraOption: {
        tooltip: {
          trigger: 'axis',
          formatter: (params)=>{
            let str=`<div>${params[0].name}</div>`
            params.forEach(item => {
              str+=`<div style='display:flex;'>
                      <div>${item.marker} </div>
                      <div style='width:90px'>${item.seriesName}</div>
                      <div style='font-weight:600;'>${(item.value).toFixed(0)}</div>
                    </div>`
            });
            return str
          }
        },
        grid: {
          top: '20%',
          left: 0,
          right: '2%',
          bottom: 0,
          containLabel: true,
        },
        legend: {
          itemHeight: this.fitChartSize(0),
          data: [
            {
              top: '2%',
              right: '30%',
              name: '用电量',
              textStyle: {
                color: '#CCCCCC',
                fontSize: this.fitChartSize(12),
              },
            },
            {
              top: '2%',
              left: '30%',
              name: 'V2G放电量',
              textStyle: {
                color: '#CCCCCC',
                fontSize: this.fitChartSize(12),
              },
            },
          ],
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#A4A4A4',
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            // y轴刻度线
            show: false,
          },
        },
        yAxis: [
          {
            name: '用电量(kWh)',
            nameGap: this.fitChartSize(21),
            nameTextStyle: {
              color: '#fff',
              align: 'right',
              fontSize: this.fitChartSize(12),
              padding: [0, this.fitChartSize(-60), this.fitChartSize(-3), 0],
            },
            type: 'value',
            axisLabel: {
              color: '#c5c5c5',
              fontSize: this.fitChartSize(12),
              margin: this.fitChartSize(6),
            },
            splitLine: {
              show: true,
              lineStyle: {
                width: 1,
                color: 'rgba(43, 196, 255, 1)',
                type: 'dashed',
              },
            },
          },
          {
            type: 'value',
            show: false,
            name: 'V2G放电量(kWh)',
            nameTextStyle: {
              padding: [0, this.fitChartSize(4), this.fitChartSize(4), 0],
              color: '#FFFFFF',
            },
            axisLabel: {
              show: true,
              textStyle: {
                fontSize: this.fitChartSize(12),
                color: '#C5C5C5',
              },
            },
            min: 0, // y轴的最小值
            axisLine: {
              show: false,
            },
            axisTick: {
              // y轴刻度线
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                width: 1,
                color: 'rgba(43, 196, 255, 1)',
                type: 'dashed',
              },
            },
          },
        ],
        series: [
          {
            name: '用电量',
            type: 'line',
            yAxisIndex: 0,
            itemStyle: {
              color: '#32BAFF',
              shadowColor: '#32BAFF',
              shadowBlur: 8,

            },
            lineStyle: {
              color: '#32BAFF',
            },
            symbol: 'circle',
            symbolSize: 4,
          },
          {
            name: 'V2G放电量',
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              color: '#FF9C59',
              shadowColor: 'rgba(255, 156, 89, 1)',
              shadowBlur: 8,
            },
            lineStyle: {
              color: '#FF9C59',
            },
            symbol: 'circle',
            symbolSize: 4,
          },
        ],
      },
    };
  },
  mounted() {

  },
  methods: {
    handleNavGo() {
      this.$emit('handleNavGo');
    },
  },
};
</script>

<style lang="less" scoped>
.cumulative-ele {
  ::v-deep .pub-info-title {
    margin-bottom: 18px;
  }
  #eleLine {
    width: 100%;
    height: 170px;
  }
  .chart-container {
    width: 437px;
    height: 172px;
    // margin-bottom: 12px;
  }
}
</style>
